/**
 * TriagePill — Guardian's advisory read of a drift row, as an outline tag in
 * the queue.
 *
 * The Drift Triage Copilot writes a *suggestion* onto open rows (it never
 * disposes them — the human approves). When a row carries a surfaceable
 * suggestion, this tag names the read in advisor voice ("Likely routine
 * churn") and carries the confidence + rule-vs-AI provenance on its hover
 * title and, for screen readers, as visually hidden text. A `RealChange` or
 * un-triaged row renders nothing — silence is the default, so the queue stays
 * neutral unless Guardian actually has an opinion.
 *
 * Carbon outline tag (DESIGN.md "Chips"): a read is neither a state nor a
 * pillar, so it carries no hue. All words come from `drift-decision-copy` so
 * the jargon sweep is enforced in one place.
 */

import { Tag } from '@/components/carbon/Tag'
import {
  triageSuggestionCopy,
  type DriftTriageFields,
} from '@/lib/drift-decision-copy'

export default function TriagePill({ fields }: { fields: DriftTriageFields }) {
  const copy = triageSuggestionCopy(fields)
  if (!copy) return null

  return (
    <Tag kind="outline" title={copy.title}>
      {copy.pill}
      {/* The title is mouse-only; the same words reach assistive tech here. */}
      <span className="sr-only">. {copy.title}</span>
    </Tag>
  )
}
